'use client'

import { getPlayListSort, setPlayListSort } from 'app/lib/playListSort'
import { createContext, useContext, useState, type ReactNode } from 'react'
import type { PlayListSortType } from '~/features/play_list/components/buttons/PlayListSortButton/constants'

type PlayListSortContextType = {
  sortType: PlayListSortType
  updateSortType: (sortType: PlayListSortType) => void
}

const PlayListSortContext = createContext<PlayListSortContextType | undefined>(undefined)

export const PlayListSortProvider = ({ children }: { children: ReactNode }) => {
  const [sortType, setSortType] = useState<PlayListSortType>(() => getPlayListSort())

  const updateSortType = (newSortType: PlayListSortType) => {
    setPlayListSort(newSortType)
    setSortType(newSortType)
  }

  return (
    <PlayListSortContext.Provider value={{ sortType, updateSortType }}>
      {children}
    </PlayListSortContext.Provider>
  )
}

export const usePlayListSort = () => {
  const context = useContext(PlayListSortContext)
  if (context === undefined) {
    throw new Error('usePlayListSort must be used within PlayListSortProvider')
  }
  return context
}
